import { render, staticRenderFns } from "./LandingChainBanner.vue?vue&type=template&id=3fb7116c&scoped=true"
import script from "./LandingChainBanner.vue?vue&type=script&lang=js"
export * from "./LandingChainBanner.vue?vue&type=script&lang=js"
import style0 from "./LandingChainBanner.vue?vue&type=style&index=0&id=3fb7116c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb7116c",
  null
  
)

export default component.exports